var __jsx = React.createElement;
import * as React from 'react';
import * as ds from '@bob/design-system';
import * as logger from '@bob/logger';
export function Pagination(_ref) {
  var _ref$engine = _ref.engine,
      ready = _ref$engine.ready,
      result = _ref$engine.result,
      pagination = _ref$engine.pagination;

  if (result.status === 'request' || !ready) {
    return null;
  }

  return __jsx(ds.Pagination, {
    href: function href(page) {
      return pagination.pageHref(page);
    },
    onNavigate: function onNavigate() {
      var anchor = document.getElementById('top');

      if (!anchor) {
        logger.err("[Pagination] Couldn't find an anchor to scroll to");
        return;
      }

      var headerOffset = 85;
      var position = anchor.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    },
    pageCount: pagination.pages.length,
    selectedPage: pagination.page
  });
}